import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    LocationAreasFields,
} from '../LocationAreas.types'

const getAdditionalFeesColumns = (
    l: (l:string) => string,
): RichTableColumns<LocationAreasFields>[] => {
    return [
        {
            id: 'areaName',
            mapCellProps: 'areaName',
            headerProps: {
                children: l('AREA_NAME'),
            },
        },
        {
            id: 'latitude',
            mapCellProps: 'latitude',
            headerProps: {
                children: l('LATITUDE'),
            },
        },
        {
            id: 'longitude',
            mapCellProps: 'longitude',
            headerProps: {
                children: l('LONGITUDE'),
            },
        },
        {
            headerProps: {
                children: l('CHANGED_ON'),
            },
            id: 'changedOn',
            mapCellProps: 'changedOn',
            componentName: 'DateTimeCell',
        },
        {
            headerProps: {
                children: l('CHANGED_BY'),
            },
            id: 'changedBy',
            mapCellProps: 'changedBy',
        },
    ]
}

export default getAdditionalFeesColumns
